import type { CommandPaletteNavigateOutcome } from '../command-palette/command-palette.models';

import type { VulnerabilityLookupItem } from './vulnerability-search.models';

/**
 * The single result to auto-forward to: one match whose id equals the query.
 * Alias matches (different id) and advisory queries (multiple results) return
 * null so the palette can let the user acknowledge them.
 */
export const getExactMatch = (
  query: string,
  results: VulnerabilityLookupItem[],
) => {
  if (results.length !== 1) return null;

  const [match] = results;

  return match.vulnerabilityId.toLowerCase() === query.toLowerCase()
    ? match
    : null;
};

/**
 * The palette outcome for a vulnerability result: navigate to the CVE's detail
 * page. Shared by the row's link and the keyboard/exact-match paths so the
 * destination has a single source of truth.
 */
export const vulnerabilitySearchOutcome = (
  vulnerabilityId: string,
): CommandPaletteNavigateOutcome => ({
  kind: 'navigate',
  to: `/search/vulnerabilities/${encodeURIComponent(vulnerabilityId)}`,
});
